module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "distributor-manager"
  }, [_c('div', {
    staticClass: "dis-manager-search white-box"
  }, [_c('div', {
    staticClass: "part"
  }, [_c('span', {
    staticClass: "span-14"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('el-input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.filterTerm.name),
      callback: function($$v) {
        _vm.$set(_vm.filterTerm, "name", $$v)
      },
      expression: "filterTerm.name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('span', {
    staticClass: "span-14"
  }, [_vm._v("手机号")]), _vm._v(" "), _c('el-input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": "请输入手机号"
    },
    on: {
      "blur": _vm.bl
    },
    model: {
      value: (_vm.filterTerm.mobile),
      callback: function($$v) {
        _vm.$set(_vm.filterTerm, "mobile", $$v)
      },
      expression: "filterTerm.mobile"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('span', {
    staticClass: "span-14"
  }, [_vm._v("创建时间")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "align": "right",
      "type": "date",
      "placeholder": "选择起始日期"
    },
    model: {
      value: (_vm.filterTerm.createdAtStart),
      callback: function($$v) {
        _vm.$set(_vm.filterTerm, "createdAtStart", $$v)
      },
      expression: "filterTerm.createdAtStart"
    }
  }), _vm._v(" "), _c('span', [_vm._v("-")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "align": "right",
      "type": "date",
      "placeholder": "选择终止日期"
    },
    model: {
      value: (_vm.filterTerm.createdAtEnd),
      callback: function($$v) {
        _vm.$set(_vm.filterTerm, "createdAtEnd", $$v)
      },
      expression: "filterTerm.createdAtEnd"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('span', {
    staticClass: "span-14"
  }, [_vm._v("状态")]), _vm._v(" "), _c('el-select', {
    model: {
      value: (_vm.filterTerm.accountState),
      callback: function($$v) {
        _vm.$set(_vm.filterTerm, "accountState", $$v)
      },
      expression: "filterTerm.accountState"
    }
  }, _vm._l((_vm.distributorStatus), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "part"
  }, [_c('span', {
    staticClass: "span-14"
  }, [_vm._v("身份证")]), _vm._v(" "), _c('el-input', {
    staticClass: "search-input",
    attrs: {
      "placeholder": "请输入身份证号"
    },
    model: {
      value: (_vm.filterTerm.idCardNo),
      callback: function($$v) {
        _vm.$set(_vm.filterTerm, "idCardNo", $$v)
      },
      expression: "filterTerm.idCardNo"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.loading,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.filter(0)
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), (_vm.accountState === 1 && _vm.promotorType === 1) ? _c('el-button', {
    on: {
      "click": function($event) {
        _vm.toInfo(0, 0)
      }
    }
  }, [_vm._v("添加分销商")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dis-manager-table white-box"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "row-class-name": "dis-manager-table-tr",
      "data": _vm.queryData.promotors
    }
  }, [_vm._l((_vm.distriTableColumn), function(item) {
    return _c('el-table-column', {
      key: item.prop,
      attrs: {
        "prop": item.prop,
        "label": item.label,
        "width": item.width
      }
    })
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.toInfo(scope.row.id, 1)
            }
          }
        }, [_vm._v("查看")]), _vm._v(" "), (scope.row.accountState == '在职' && _vm.accountState === 1 && _vm.promotorType === 1) ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.toInfo(scope.row.id, 0)
            }
          }
        }, [_vm._v("编辑\n          ")]) : _vm._e(), _vm._v(" "), (scope.row.accountState == '在职' && _vm.accountState === 1 && _vm.promotorType === 1) ? _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.dimission(scope.row.id)
            }
          }
        }, [_vm._v("离职\n          ")]) : _vm._e()]
      }
    }])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "dis-manager-pag column-content"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.queryData.curPage,
      "page-sizes": [10, 20, 30, 40],
      "page-size": _vm.queryData.pageSize,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.queryData.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.$set(_vm.queryData, "curPage", $event)
      }
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a7a1587","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/distributorMana/distributorManager.vue
// module id = 921
// module chunks = 1